<template>
    <div class="flex flex-col justify-center">
        <template v-if="extension.calls.length">
            <call-info
                v-for="call in extension.calls"
                :key="call.ivrid"
                :call="call"
                :hide-call-info="hideCallInfo"
                :hide-caller-info="hideCallerInfo"
                :settings="settings"
                :text-color="'text-white'"
            >
                <template #threshold="{statusThreshold}">
                    <component
                        :is="statusThreshold.icon"
                        v-if="statusThreshold.show"
                        class="w-6 mb-1 mx-2"
                    />
                </template>
            </call-info>
        </template>
        <div v-else>
            {{ $t('widget.table.noCallers') }}
        </div>
    </div>
</template>
<script>

export default {
    components: {
        CallInfo: () => import('@/components/Cards/CallInfo.vue')
    },
    props: {
        extension: {
            type: Object,
            default: () => ({})
        },
        settings: {
            type: Object,
            default: () => ({})
        },
        hideCallerInfo: {
            type: Boolean,
            default: false,
        },
        hideCallInfo: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
